<template>
    <div>
        <Header />
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <main class="app-content">
            <div class="app-title">
                <div class="col-md-3 col-lg-3" style="margin-top: 15px; height:40px">
                    <div class="about-content">
                        <p @click="routeLeasing()" id="btnCekiGir">
                            LEASİNG PLANLAMA   
                        </p>
                    </div>
                </div>
                <div class="col-md-3 col-lg-3" style="margin-top: 15px; height:40px">
                    <div class="about-content">
                        <p @click="routeEntryCheckCari()" id="btnCekiGir">
                            NAKİT ÖDEME TAKVİMİ
                        </p>
                    </div>
                </div>
                <div class="col-md-3 col-lg-3" style="margin-top: 15px; height:40px">
                    <div class="about-content">
                        <p @click="routeCheckMusteriCeks()" id="btnCekiGir">
                            MÜŞTERİ ÇEKLERİ
                        </p>
                    </div>
                </div>
                <div class="col-md-3 col-lg-3" style="margin-top: 15px; height:40px">
                    <div class="about-content">
                        <p @click="routeEntryCheckCari()" id="btnCekiGir">
                            CARİ ÇEKİ GİRİNİZ
                        </p>
                    </div>
                </div>
            </div>
            <div style="margin:auto ; position : center" aria-labelledby="navbarDropdown">
                <!-- <input class="form-control py-2 border-left-0 border" type="search" value="..." id="example-search-input"> -->
                <input class="form-control py-2 border-left-0 border" style="width:100%;border-radius:0.25rem"
                    type="search" v-model="searchString" placeholder="ARATMAK İSTEDİĞİNİZ ÇEK NUMARASINI YAZINIZ" />
                <div style="width: 700px;position: absolute; z-index:3;">
                    <ul class="searchCss" style="">
                        <li v-for="result in results" :key="result.id">
                            <hr />
                            <div @click="routeDetail(result)"
                                style="padding-right: 5px;padding-left: 5px;font-size: 15px;color: black;">

                                {{ result.id + "~ VADE : " + result.vade + "~" + result.firmaname + "~ SERİ NO :" +
                                    result.serino + "~ ÇEK TUTARI : " + result.tutar + "₺" }}

                            </div>
                        </li>
                    </ul>
                    <br>

                </div>

            </div>
            <br>
            <div class="row">
                <div class="col-lg-12 col-md-12 justify-content-md-center rowHomepage">
                    <div class="col-md-3 col-lg-3" style="margin-bottom: 45px; height:80px">
                        <div class="tileHomepage hover-div2 backgroundbutton">
                            <div class="about-content">
                                <p @click="routeEntryCheckCustomer()" id="btnCekiGir">
                                    MÜŞTERİ ÇEKİ GİRİNİZ
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3 col-lg-3" style="margin-bottom: 45px; height:80px">
                        <div class="tileHomepage hover-div2 backgroundbutton">
                            <div class="about-content">
                                <p @click="routeEntryCheckCari()" id="btnCekiGir">
                                    CARİ ÇEKİ GİRİNİZ
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3 col-lg-3" style="margin-bottom: 45px; height:80px">
                        <div class="tileHomepage hover-div2 backgroundbutton">
                            <div class="about-content">
                                <p @click="routeCariList()" id="btnCekiGir">
                                    ÇEK ÖZET VE ANALİZİ
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3 col-lg-3" style="margin-bottom: 45px; height:80px">
                        <div class="tileHomepage hover-div2 backgroundbutton">
                            <div class="about-content">
                                <p @click="routePage2()" id="btnCekiGir">
                                    VADESİ DOLAN ÇEKLER
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12 col-md-12 justify-content-md-center rowHomepage">
                    <div v-for="(item, index) in sahalar" :key="index" class="col-md-4 col-lg-4"
                        style="margin-bottom: 22px; height:110px">
                        <div class="tileHomepage hover-div2 deneme">
                            <div class="about-content">
                                <p @click="routePage(sahalar[index])" id="kirmizi">
                                    {{ formatTarih(sahalar[index].vade) }} ~
                                    {{ sahalar[index].firmaname }} ~ ÇEK :
                                    {{ sadeFormat(sahalar[index].tutar) }}₺ ~ KALAN:
                                    {{ sadeFormat(sahalar[index].kalantutar) }}₺
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>

        <Sidebar />
    </div>
</template>

<script>
import Header from "./default/Header";
import Sidebar from "./default/Sidebar";
import axios from "axios";
import store from "../store";
import { debounce } from "lodash";
export default {
    data() {
        return {
            searchString: "",
            results: [],
            product: [],
            sahalar: [],
            raporlar: [],
            token: "",
            control: "",
        };
    },
    watch: {
        searchString: debounce(function () {
            this.search();
        }, 250),
        $route() {
            $("#navbarSupportedContent").collapse("hide");
        },
    },
    methods: {
        search: function () {
            if (this.searchString.length > 0) {
                axios
                    .get(
                        `https://www.apidosya.aslanyazilimm.com/DosyaApi/Cek/searchCheck.php?key=123&keyword=${this.searchString}`
                    )
                    .then((response) => {
                        if (response.data == null) {
                            this.results = [
                                {
                                    id: "NULL",
                                    firmaname: "NULL",
                                    serino: "NULL",
                                    vade: "NULL",
                                    tutar: "NULL",
                                    maincek: "NULL"
                                }
                            ]
                        } else {
                            var deger = response.data.length;
                            if (deger > 50) {
                                this.results = response.data.slice(0, 50);
                            } else {
                                this.results = response.data;

                            }
                        }

                    });
            } else {
                this.results = null;
            }
        },
        formatTarih(isoTarih) {
            const tarihObjesi = new Date(isoTarih);
            const gun = String(tarihObjesi.getDate()).padStart(2, '0');
            const ay = String(tarihObjesi.getMonth() + 1).padStart(2, '0'); // Ay 0-indexli!
            const yil = tarihObjesi.getFullYear();

            return `${gun}.${ay}.${yil}`;
        },
        sadeFormat(tutar) {
            return new Intl.NumberFormat('tr-TR').format(tutar);
        }
        ,
        routeEntryCheckCustomer: function () {
            window.location.href = "#/checkscustomerentry";
        },
        routeCheckMusteriCeks: function () {
            window.location.href = "#/checksmustericeki";
        },
        routeEntryCheckCari: function () {
            window.location.href = "#/checkscarientry";
        },
        routeCariList: function () {
            window.location.href = "#/carilist";
        },
        routeLeasing: function () {
            window.location.href = "#/leasing";
        },
        routePage: function (item) {
            window.location.href = "#/checksmain?idm=" + item.id;
        },
        routePage2: function (item) {
            window.location.href = "#/checksCariComplate";
        },
        routeDetail: function (item) {
            if (item.maincek > 0) {
                window.location.href = "#/checksmain?idm=" + item.maincek;
            } else {
                window.location.href = "#/checksmain?idm=" + item.id;
            }
        },
    },
    mounted() {
        window.scrollTo(0, 0);
        var id = localStorage.getItem("id");
        var token = localStorage.getItem("token");
        if (!token) {
            alert(
                "Yetkisiz İşlem Yapılmaya Çalışıldı Giriş Sayfasına Yönlendirileceksiniz"
            );
            this.$store.dispatch("logout");
        }
        var datas = {
            id: id,
            token: token,
        };
        var url = store.state.base_url + "Cek/getAllCekMain.php?key=123";
        axios
            .post(url, JSON.stringify(datas))
            .then((response) => {
                this.sahalar = response.data.data;
            })
            .catch((err) => {
                console.log(err.response);
            });

        setTimeout(function () {
            //  alert("Sayfa yenilendi");
            window.location.reload(1);
        }, 2500000);
    },
    components: {
        Header,
        Sidebar,
    },
};
</script>

<style>
.col-md-3 {
    /* Burada, mobil ekranlarda 1 sütun genişliği belirleyebilirsiniz */
    width: 100%;
}

.rowHomepage {
    /* Satırların taşma yapmaması için esnek ayarlar yapabilirsiniz */
    display: flex;
    flex-wrap: wrap;
    /* Satırların alt alta yerleşmesini sağlar */
    justify-content: center;
    /* İçerikleri yatay olarak ortalar */
}

.backgroundbutton {
    background: #ccc;
}

#kirmizi {
    border-radius: 15px 50px;
    background-color: #f0eded;
    text-align: center;
    font-size: 25px;
}

#kirmiziM {
    border-radius: 15px 50px;
    background-color: #f77070;
    text-align: center;
    font-size: 25px;
}

.searchCss {
    border-radius: 6px;
    background-color: white;
}

#turuncu {
    border-radius: 15px 50px;
    background-color: #ff9900;
    text-align: center;
    font-size: 25px;
}

#sari {
    border-radius: 15px 50px;
    background-color: #f4ff2d;
    text-align: center;
    font-size: 25px;
}

#yesil {
    border-radius: 15px 50px;
    background-color: #76f118;
    text-align: center;
    font-size: 25px;
}

#mavi {
    border-radius: 15px 50px;
    background-color: #19c6f1;
    text-align: center;
    font-size: 25px;
}

#pid1:hover {
    border-radius: 15px 50px;
    background-color: #63ca92;
    text-align: center;
    font-size: 25px;
}

#pid2:hover {
    border-radius: 15px 50px;
    background-color: #63ca92;
    text-align: center;
    font-size: 25px;
}

#pid3:hover {
    border-radius: 15px 50px;
    background-color: #63ca92;
    text-align: center;
    font-size: 25px;
}

#pid4:hover {
    border-radius: 15px 50px;
    background-color: #63ca92;
    text-align: center;
    font-size: 25px;
}

#btnCekiGir {
    /* Aynı stilleri burada da uygulayabilirsin */
    background-color: #fff;
    border: 1px solid #ccc;
    padding: 12px 24px;
    border-radius: 8px;
    text-decoration: none;
    font-size: 15px;
    transition: 0.3s;
    text-align: center;
    font-family: Georgia, 'Times New Roman', Times, serif;
}

#btnCekiGir:hover {
    background-color: #b7f4c8;
}
</style>



// WEBPACK FOOTER //
// src/components/BankChecks.vue